import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { ShortcutCard, ShortcutCardGroup } from '@eika/card/lib/ShortcutCard';
import { LargeCenteredContainer, LayoutItem, SevenFourContainer } from '@eika/engine-view';
import { IconTypes } from '@eika/icon';

import { FavoriteAccount, FavoriteAccountSkeleton } from '../../components/FavoriteAccount';
import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';
import { AccountOverviewContent, AccountsGroupLoader } from '../AccountOverview/components';
import mapAllAccountCardItems from '../EditAccountOverview/components/DragAndDropAccountsList/mapAccountCardItems';
import DemoActions from './components/DemoActions';
import { favoriteAccount, visibleAccounts } from './demoData';

const DemoView: React.FC = () => {
    const translated = useTranslation();
    const [isLoading, setLoading] = useState(true);

    const { paymentPageLink, loanLink, demoCurrencyCalculatorLink } = useConfig();

    useEffect(() => {
        setTimeout(() => setLoading(false), 1000);
    }, []);

    return (
        <div>
            <LargeCenteredContainer layoutClassNames="themed">
                <div className={classnames('favorite-account-widget', { native: runningInRNWebView })}>
                    {isLoading && <FavoriteAccountSkeleton />}

                    {!isLoading && (
                        <FavoriteAccount
                            className={classnames({ native: runningInRNWebView })}
                            account={favoriteAccount}
                        />
                    )}
                    <DemoActions />
                </div>
            </LargeCenteredContainer>
            <SevenFourContainer>
                <SevenFourContainer.Seven>
                    {(!!paymentPageLink || !!loanLink || !!demoCurrencyCalculatorLink) && (
                        <ShortcutCardGroup title="">
                            {paymentPageLink?.url && (
                                <ShortcutCard
                                    data-test-id="demo-shortcut"
                                    link={paymentPageLink?.url}
                                    text="Betaling"
                                    icon={IconTypes.BETALE_36}
                                />
                            )}
                            {loanLink?.url && (
                                <ShortcutCard
                                    data-test-id="demo-shortcut"
                                    link={loanLink?.url}
                                    text="Lånesøknad"
                                    icon={IconTypes.HUS_36}
                                />
                            )}
                            {demoCurrencyCalculatorLink?.url && (
                                <ShortcutCard
                                    data-test-id="demo-shortcut"
                                    link={demoCurrencyCalculatorLink?.url}
                                    text="Valutakalkulator"
                                    icon={IconTypes.PENGESEKK_36}
                                />
                            )}
                        </ShortcutCardGroup>
                    )}

                    <LayoutItem>
                        {isLoading && <AccountsGroupLoader numberOfItems={2} />}
                        {!isLoading && (
                            <AccountOverviewContent
                                accountCardItems={mapAllAccountCardItems(visibleAccounts, [])}
                                header={translated.accountOverview.headingMobile}
                            />
                        )}
                    </LayoutItem>
                </SevenFourContainer.Seven>
            </SevenFourContainer>
        </div>
    );
};

export default DemoView;
